import { render } from "./userProfile.vue?vue&type=template&id=23a3114d"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"

import "./userProfile.vue?vue&type=style&index=0&id=23a3114d&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__